import { Slider } from "../slider/slider";

export class TvScheduleTabs {
    defaultOptions = {
        wrapperClass: 'structure__content__carousel',
        slideClass: 'tv-schedule__item__carousel',
        slidesPerView: 3,
        breakpoints: {
            992: {
                slidesPerView: 3
            },
            820: {
                slidesPerView: 2
            },
            548: {
                slidesPerView: 2
            }
        },
        navigation: {
            prevEl: '.tv-schedule__navigation__carousel--prev',
            nextEl: '.tv-schedule__navigation__carousel--next'
        }
    };

    swiper;
    structures;

    constructor(slider) {
        this.slider = slider;
        this.init();
    }

    init() {
        this.bindEvents();
        this.setStructure();
        this.getItemLive();
    }

    bindEvents() {
        const activeNavItem = document.querySelector('.tv-schedule__nav__item--active');
        if (activeNavItem) {
            const dataIndex = activeNavItem.dataset.index;
            this.activateTab(dataIndex);

            document.querySelectorAll('.tv-schedule__nav__item').forEach((anchor, index) => {
                anchor.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    this.changeTab(anchor, index);
                });
            });
        }
    }

    activateTab(dataIndex) {
        document.querySelector(`.tv-schedule__list[data-index="${dataIndex}"]`).classList.add('tv-schedule__list--active');
    }

    changeTab(anchor, index) {
        // Reset active state
        document.querySelectorAll('.tv-schedule__nav__item').forEach(element => element.classList.remove('tv-schedule__nav__item--active'));
        anchor.classList.add('tv-schedule__nav__item--active');

        // Activate corresponding tab
        document.querySelectorAll('.tv-schedule__list').forEach((tab, i) => {
            tab.classList.remove('tv-schedule__list--active');
            if (i === index) {
                tab.classList.add('tv-schedule__list--active');
                this.setStructure();

                // Slide to active item
                const bodyItems = $(tab).find('.tv-schedule__item');
                const indexActive = bodyItems.toArray().findIndex(item => $(item).hasClass('tv-schedule__item--active'));
                if (indexActive !== -1 && this.swiper) {
                    this.swiper.slideTo(indexActive);
                }
            }
        });
    }

    setStructure() {
        const activeList = $(this.slider).find('.tv-schedule__list--active .md-slider-tvschedule-carousel');
        if (!activeList.length) {
            return;
        }

        this.swiper = new Slider(activeList[0], this.defaultOptions);
    }

    // Función que muestra sincronizada la hora del sistema con "Ahora en emisión".
    getItemLive() {
        const date = new Date();
        const timestamp = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

        const bodyItems = $('.tv-schedule__list--active').find('.tv-schedule__item');
        if (!bodyItems.length) {
            return;
        }

        for (let i = 0; i < bodyItems.length; i++) {
            // Etiqueta donde contiene el rango de horas de emisión (formato "hora inicial - hora final").
            const scheduleHour = bodyItems[i].getElementsByTagName("p")[0].innerText.trim();
            // Separamos la hora inicial y final con el split('-').
            const [initialHour, finalHour] = scheduleHour.split('-').map(hour => hour.replace('.', ':').trim());

            // Si la fecha de cierre es del día siguiente, no hay más que mirar
            if (!timestamp.split(':')[0].startsWith('0') // Estamos después de las 12
                && finalHour.split(':')[0].startsWith('0') // Acaba mañana
                && initialHour <= timestamp
                && finalHour < initialHour
            ) {
                // SI llegamos aquí es porque la fecha de inicio es anterior y la de fin es para mañana, así que es el item actual
                bodyItems[i].classList.add('tv-schedule__item--active');

                // Se hace slide a la hora actual
                if (this.swiper) {
                    this.swiper.slideTo(i);
                }

                continue;
            }

            // Si llegamos aquí hacemos el control normal de las horas
            if (initialHour <= timestamp && timestamp < finalHour) {
                bodyItems[i].classList.add('tv-schedule__item--active');

                // Se hace slide a la hora actual
                if (this.swiper) {
                    this.swiper.slideTo(i);
                }
            }
        }
    }
}
